let curr = 0;

export const nextId = () => curr++;